import { computed } from 'vue';
import { useStore } from '@/utils/vue-api';
import { useCommonData } from '@/hooks';
import { IRSTORE_T_VIEW } from '@/utils/track';
import { resolveStoreId, resolvePageId } from '@rebuild/utils/context';

/**
 * 模块显示控制
 * 根据配置和页面状态控制各功能模块的显示/隐藏
 */
export function useModuleDisplay() {
	const store = useStore();
	const { getFeedbackEntry, getSurveyEntry, getSubscription } = useCommonData();

	const allModules = computed(() => store.getters.getPageAllModules);

	const getModuleName = moduleId => {
		const module = allModules.value.find(m => m.moduleId === moduleId);
		return module?.name || '';
	};

	const trackAction = type => {
		// 模块名称映射
		const moduleNameMap = {
			'survey': '预约调研',
			'feedback': '投资者留言',
			'subscription': '邮件订阅',
			'whistleblower': '举报功能'
		};
		const moduleName = moduleNameMap[type] || type;

		IRSTORE_T_VIEW(282, {
			params: {
				浏览模块名称: moduleName,
				浏览模块类型: '系统默认模块',
				企业ID: resolveStoreId(),
				页面ID: resolvePageId()
			}
		});
	};

	return {
		getSurveyEntry,
		getSubscription,
		getFeedbackEntry,

		// 工具方法
		getModuleName,
		trackAction
	};
}
